export default __webpack_public_path__ + "static/hiit_it_interval_timer_iphone-reset@3x-526e19d0f93373f2763d6199f7275a0c.webp";